import { SelectItem } from "@com.mgmtp.a12.widgets/widgets-core";

import { EmpfaengerTyp } from "./types";

export const EMPFAENGER_TYPS: SelectItem[] = [
	{ value: "AN", label: "An" },
	{ value: "CC", label: "Cc" },
	{ value: "BCC", label: "Bcc" }
];

export const CONTACT_LIST_NODE_MODEL = "contactList_Node_D";
export const CONTACT_ENTRY_MODEL = "contactEntry_D";
export const CONTACT_RELATIONSHIP_MODEL = "contactList_Content_R";

export const DEFAULT_EMPFAENGER_TYP: EmpfaengerTyp = "AN";

/**
 * Transport constant used to represent an empty-string client identifier in HTTP query parameters.
 * An empty string is a valid client value (meaning "no client set") but cannot be reliably
 * transported as an empty query param value across all HTTP clients and servers.
 * This constant is substituted on the frontend before the API call and resolved back to ""
 * on the backend before any client-constraint logic is applied.
 */
export const EMPTY_CLIENT_TRANSPORT = "__EMPTY_CLIENT__";
